const today = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Paris" });
const maxDate = () => { const d = new Date(); d.setFullYear(d.getFullYear() + 1); return d.toLocaleDateString("sv-SE", { timeZone: "Europe/Paris" }); };
export const emptyGift = () => ({ recipient_name: "", recipient_email: "", sender_name: "", message: "", send_date: today() });

const field = "w-full rounded-2xl bg-white/10 border border-[#C9A24B]/40 text-[#F6F2E9] placeholder:text-[#F6F2E9]/40 px-4 py-2.5 font-sans text-sm focus:outline-none focus:border-[#C9A24B]";

export const CoffretGiftForm = ({ gift, setGift }) => {
  const set = (k) => (e) => setGift({ ...gift, [k]: e.target.value });
  return (
    <div className="mt-4 grid gap-3 text-left animate-in fade-in duration-300" data-testid="coffret-gift-form">
      <div className="grid sm:grid-cols-2 gap-3">
        <input className={field} placeholder="Prénom du proche" value={gift.recipient_name} onChange={set("recipient_name")} maxLength={60} data-testid="gift-recipient-name" />
        <input className={field} type="email" placeholder="E-mail du proche *" value={gift.recipient_email} onChange={set("recipient_email")} data-testid="gift-recipient-email" />
      </div>
      <input className={field} placeholder="Votre prénom (signature) *" value={gift.sender_name} onChange={set("sender_name")} maxLength={60} data-testid="gift-sender-name" />
      <div>
        <textarea className={field} rows={3} placeholder="Votre message personnalisé" value={gift.message} onChange={set("message")} maxLength={500} data-testid="gift-message-input" />
        <p className="text-right font-sans text-[11px] text-[#F6F2E9]/40">{gift.message.length}/500</p>
      </div>
      <label className="font-ui text-xs text-[#F6F2E9]/70">
        Date d'envoi de l'e-mail cadeau
        <input type="date" className={`${field} mt-1 [color-scheme:dark]`} min={today()} max={maxDate()} value={gift.send_date} onChange={set("send_date")} data-testid="gift-send-date" />
      </label>
      <p className="font-sans text-[11px] text-[#F6F2E9]/50">Le jour choisi, votre proche reçoit votre message et un lien pour ouvrir son coffret (envoyé le matin, ou tout de suite si c'est aujourd'hui).</p>
    </div>
  );
};
